"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const should_cache_decorator_1 = require("../cache-support/should-cache.decorator");
const should_reset_cache_decorator_1 = require("../cache-support/should-reset-cache.decorator");
const array_models_1 = require("../models/array.models");
const authenticated_client_1 = require("./authenticated.client");
class CrudClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.version = 'v1';
    }
    getAll(projectId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(projectId, null, { fields });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    search(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(parameters.projectId, null, parameters);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getById(projectId, id, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(projectId, id, { fields });
            const response = yield this.httpGet(url, { returnNullOn404: true, throwOnError: true });
            return response.payload;
        });
    }
    update(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = entity.projectId;
            const id = entity.id;
            if (!projectId || !id) {
                throw new Error('Project ID and Segment ID are required.');
            }
            const url = this.getPath(projectId, id);
            const payload = this.getUpdatePayloadModel(Object.assign(Object.assign({}, entity), { creatorId: undefined, id: undefined, projectId: undefined }), 'put');
            const response = yield this.httpPut(url, payload);
            return response.payload;
        });
    }
    create(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = entity.projectId;
            if (!projectId) {
                throw new Error('Project ID are required.');
            }
            const url = this.getPath(projectId);
            const payload = this.getUpdatePayloadModel(Object.assign(Object.assign({}, entity), { updaterId: undefined, projectId: undefined }), 'post');
            const response = yield this.httpPost(url, payload);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(projectId, id);
            yield this.httpDelete(url);
        });
    }
    getPath(projectId, path, parameters) {
        let result = `/${this.version}/projects/${projectId}/${this.entityPath}`;
        path = (path && path.toString());
        if (path && path[0] === '/') {
            result += path;
        }
        else if (path) {
            result += `/${path}`;
        }
        if (parameters) {
            result += `?${this.getQueryString(parameters)}`;
        }
        return result;
    }
    getUpdatePayloadModel(entity, _) {
        return entity;
    }
}
__decorate([
    should_cache_decorator_1.ShouldCache,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, array_models_1.FieldArray]),
    __metadata("design:returntype", Promise)
], CrudClient.prototype, "getAll", null);
__decorate([
    should_cache_decorator_1.ShouldCache,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrudClient.prototype, "search", null);
__decorate([
    should_cache_decorator_1.ShouldCache,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number, Object]),
    __metadata("design:returntype", Promise)
], CrudClient.prototype, "getById", null);
__decorate([
    should_reset_cache_decorator_1.ShouldResetCache,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrudClient.prototype, "update", null);
__decorate([
    should_reset_cache_decorator_1.ShouldResetCache,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrudClient.prototype, "create", null);
__decorate([
    should_reset_cache_decorator_1.ShouldResetCache,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", Promise)
], CrudClient.prototype, "delete", null);
exports.CrudClient = CrudClient;
//# sourceMappingURL=crud.client.js.map